import Avatar from '@material-ui/core/Avatar';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

type NkUserAvatarProps = {
  initials: string;
  variant?: 'circle' | 'circular' | 'rounded' | 'square';
  src?: string;
  className?: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    background: {
      backgroundColor: theme.palette.background.secondary,
    },
  }),
);

const NkUserAvatar = ({ variant, className, initials }: NkUserAvatarProps) => {
  const classes = useStyles();

  return (
    <Avatar
      className={`${className} ${classes.background}`}
      variant={variant}
      children={initials}
    />
  );
};

export default NkUserAvatar;
